(function() { window.GUID_37428ae5_517b_438d_a184_7ff4abd17977 = { getGuid: function() { return "37428ae5-517b-438d-a184-7ff4abd17977"; } }; })();


//# sourceMappingURL=IHasChanged.js.map
